import drawerMenu from './theme/mobile-menu-drawer';
import gtmDelay from './theme/gtm-delay-load';
import mainNav from './theme/main-nav';
import resourceNav from './theme/resource-nav';
import events from './theme/events';


document.addEventListener('DOMContentLoaded', function () {
    /** Address HTML & Body no-js Class */
    (function () {
        /** Remove .no-js */
        // document.documentElement.classList.remove('no-js');
        // document.body.classList.remove('no-js');

        /** Replace .no-js with .js */
        document.documentElement.className =
            document.documentElement.className.replace('no-js', 'js');
        document.body.className = document.body.className.replace(
            'no-js',
            'js'
        );
    })();

    /** Call */

    drawerMenu();
    gtmDelay();
    mainNav();
    resourceNav();
    events();

});

if ( !jQuery('#subnavWrapper').length ) {
    window.addEventListener('scroll', function(){
        if ( !jQuery('.o-menu__subnav-mega').is(':visible') ) {
            var header = document.querySelector('.o-header');
            header.classList.toggle("scrolling", window.scrollY > 250);
            header.classList.toggle("headerscroll", window.scrollY > 400);
        }
    })
}

jQuery(document).on('facetwp-refresh', function() {
        
        if ( FWP.soft_refresh == true ) {
            FWP.enable_scroll = true;
        } else {
            FWP.enable_scroll = false;
        }
    });
    jQuery(document).on('facetwp-loaded', function() {
        if ( FWP.enable_scroll == true && jQuery('.article-listing').length ) {
            jQuery('html, body').animate({ scrollTop: jQuery(".article-listing").offset().top }, 300);
        }

       
    });


jQuery.fn.equalHeights = function(){

let maxHeight = 0;

    jQuery(this).each(function(){

        maxHeight = Math.max(jQuery(this).height(), maxHeight);

    });

    jQuery(this).each(function(){

        jQuery(this).height(maxHeight);

    });

};


jQuery(".make-grid").each(function() {

    jQuery(this).find(".heading").equalHeights();

//jQuery(this).find(‘.card-text’).equalHeights()

})


jQuery(document).ready(function () {

    // test of fixing duotone bug (this is being worked on by WP, hopefully a future core update will fix)
    jQuery("figure[class*='wp-duotone-']").each(function () { // Select the element divs which has class that starts with some-class-
        var classList = this.className.split(/\s+/); //get a match to match the pattern wp-duotone- and extract that classname
        for (var i = 0; i < classList.length; i++) {
            if (classList[i].includes("wp-duotone")) {
                jQuery(this).parent('.wp-block-image').addClass(classList[i]);
            }
        }
    });

    // notification bar 
    if ( jQuery("#notification-alert") ) {

        function getCookie (name) {
            let value = `; ${document.cookie}`;
            let parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        }

        let barStatus = getCookie('apg-notification-bar');

        if ( barStatus == 'offed' ) {
            jQuery("#notification-alert").hide();
        }
        else {
            jQuery("#notification-alert").show();
        }

        // close function
        jQuery(".notification__close").on('click', function() {
            jQuery("#notification-alert").slideUp(260);

            // set cookie to hide notification bar for one day
            let cookieExp = new Date(Date.now() + 86400e3);
            cookieExp = cookieExp.toUTCString();
            document.cookie = 'apg-notification-bar=offed; path=/; expires=' + cookieExp;
        });
    }
});

jQuery(window).on('resize',function () {
    // reposition mega menu dropdown on window resize
    mainNav();
});

// adjust content top padding on templates which previously had absolute-positioned headers (new header as of Mar 2024 is relative positioned)
jQuery(window).on('resize load', function() {
    if ( jQuery(".home")[0] || jQuery(".single-service")[0] ){

        let headerHeight = (parseInt(jQuery(".o-header").outerHeight())) / 2;

        if ( jQuery(".home")[0] ) {
            jQuery("main").css("margin-top", "-" + headerHeight + "px");
        } 
        if ( jQuery(".single-service")[0] ) {
            jQuery(".single-service-header").css("margin-top", "-" + headerHeight + "px");
        }
    
    }
});